import gql from 'graphql-tag'

export const newProductCreate = gql`
  mutation NewProductCreate($input: NewProductCreateInput!) {
    newProductCreate(input: $input) {
      success
    }
  }
`
